export enum WireNumberOfVisits {
  None = 'None',
  OneToFour = 'OneToFour',
  FiveOrMore = 'FiveOrMore',
  Unspecified = '',
}
